import { formatPrice } from "../../lib/format.js";
import { messages } from "../../i18n/messages.js";

interface CartTotalsProps {
  subtotal: number;
  discountTotal: number;
  total: number;
  currency: string;
}

export function CartTotals({ subtotal, discountTotal, total, currency }: CartTotalsProps) {
  return (
    <dl className="space-y-2 rounded-[16px] bg-[var(--tg-theme-secondary-bg-color,#f4f4f5)] p-4 text-sm">
      <div className="flex justify-between">
        <dt className="opacity-70">{messages.cart.subtotal}</dt>
        <dd className="font-medium">{formatPrice(subtotal, currency)}</dd>
      </div>
      <div className="flex justify-between">
        <dt className="opacity-70">{messages.cart.discount}</dt>
        <dd className="font-medium">
          {discountTotal > 0 ? `−${formatPrice(discountTotal, currency)}` : formatPrice(0, currency)}
        </dd>
      </div>
      <div className="flex justify-between border-t border-black/10 pt-2 text-base">
        <dt className="font-semibold">{messages.cart.total}</dt>
        <dd className="font-semibold">{formatPrice(total, currency)}</dd>
      </div>
    </dl>
  );
}
